export const removeOpenedClass = (...elementsToKeepOpen) => {
  const inputSearch = document.querySelector(".input-search");

  const openedElements = [...document.querySelectorAll(".burger-menu, .navigation-menu, .header__search-wrapper, .search-menu, .header__menu-opener-link")];

  openedElements.forEach(openedElement => {
    openedElement.classList.remove('opened');
   
    if (inputSearch && !elementsToKeepOpen.includes(document.querySelector(".search-menu"))) {
      inputSearch.value = "";
    }
  });

  if (elementsToKeepOpen.length > 0) {
    elementsToKeepOpen.forEach((elementToKeepOpen) => {
      elementToKeepOpen.classList.add('opened');
    })
  }
};
